import { deleteApi, get, post } from "../GenericServices";

const ExpenseRefund = {
  getExpenseRefunds: (queryString) => {
    if (queryString !== "") {
      queryString = "?" + queryString;
    }
    return get(`expense-refund${queryString}`);
  },
  getExpenseRefund: (id) => {
    return get(`expense-refund/${id}`);
  },
  getExpenseRefundExport: (queryString) => {
    if (queryString !== "") {
      queryString = "?" + queryString;
    }
    return get(`expense-refund/export${queryString}`, {}, "blob");
  },
  getExpenseRefundExportDocuments: (queryString) => {
    if (queryString !== "") {
      queryString = "?" + queryString;
    }
    return get(`expense-refund/documents/export${queryString}`, {}, "blob");
  },
  setExpenseRefund: (data) => {
    return post(`expense-refund`, data);
  },
  setExpenseRefundJustification: (data) => {
    return post(`expense-refund/justification`, data);
  },
  setExpenseRefundFlatRate: (data) => {
    return post(`expense-refund/flat-rate`, data);
  },
  setExpenseRefundKm: (data) => {
    return post(`expense-refund/km`, data);
  },
  setExpenseRefundCreditCard: (data) => {
    return post(`expense-refund/credit-card`, data);
  },
  deleteExpenseRefund: (id) => {
    return deleteApi(`expense-refund/${id}`);
  },
  uploadDocument: (id, fileData) => {
    return post(`expense-refund/${id}/upload-document`, fileData);
  },
  downloadDocument: (docId) => {
    return get(`expense-refund/download-document/${docId}`, {}, "blob");
  },
  deleteDocument: (docId) => {
    return deleteApi(`expense-refund/delete-document/${docId}`);
  },
  expenseRefundReport: () => {
    return get(`expense-refund/report`, {}, "blob");
  },
  massiveExportDocuments: (filterParams) => {
    return post(`expense-refund/massive-download-document`, filterParams);
  },
  searchDocuments: (queryString) => {
    if (queryString !== "") {
      queryString = "?" + queryString;
    }
    return get(`expense-refund/documents${queryString}`);
  },
};

export default ExpenseRefund;
